export enum TransactionDirection {
    none = 0,
    income = 1,
    outcome = 2
}